import { mergeStyleSets } from '@uifabric/styling';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPalette } from 'owa-theme';

export enum BorderIdentifier {
    // using the powers of two to use bitwise or
    Top = 1,
    Right = 2,
    Bottom = 4,
    Left = 8,
}

/**
 * Returns the border colors for a div based on the color scheme and mentioned parameters
 * @param colorScheme The color scheme used
 * @param greyedBorders Type ( A bitwise Or of the BorderIdentifiers Eg: BorderIdentifier.Top|BorderIdentifier.Right ) Borders which need to be gray -  usually the seperators between divs
 * @param excludedBorders Type ( A bitwise Or of the BorderIdentifiers Eg: BorderIdentifier.Top|BorderIdentifier.Right ) If any border need not be shown that is listed here
 */
export const notesEditorBorderColors = (
    colorScheme: ColorScheme,
    greyedBorders?: number,
    excludedBorders?: number,
    excludeFocusBorder?: boolean
) => {
    let lightColor;
    let themeSymbols = getPalette();
    if (colorScheme) {
        lightColor = colorScheme.calLight;
    } else {
        lightColor = themeSymbols.themeLight;
    }
    let textColor = (colorScheme && colorScheme.accessibleText.msColorWhiteBackground) || null;

    const borderGrayColor = `${themeSymbols.neutralLight} !important`;
    const borderFocusColor = `${textColor}  !important`;
    const borderLightColor = `${lightColor} !important`; //https://app.zeplin.io/project/596d116a601077f3575fcb24/screen/5aa83169302dfae58f8e0e0d - cal/themeLight
    let newStyle = mergeStyleSets({
        root: {
            borderTop:
                excludedBorders & BorderIdentifier.Top
                    ? 0
                    : `solid 1px ${
                          greyedBorders & BorderIdentifier.Top ? borderGrayColor : borderLightColor
                      }`,

            borderBottom:
                excludedBorders & BorderIdentifier.Bottom
                    ? 0
                    : `solid 1px ${
                          greyedBorders & BorderIdentifier.Bottom
                              ? borderGrayColor
                              : borderLightColor
                      }`,
            borderLeft:
                excludedBorders & BorderIdentifier.Left
                    ? 0
                    : `solid 1px ${
                          greyedBorders & BorderIdentifier.Left ? borderGrayColor : borderLightColor
                      }`,
            borderRight:
                excludedBorders & BorderIdentifier.Right
                    ? 0
                    : `solid 1px ${
                          greyedBorders & BorderIdentifier.Right
                              ? borderGrayColor
                              : borderLightColor
                      }`,

            selectors: !excludeFocusBorder && {
                ':focus': {
                    borderColor: borderFocusColor,
                },
            },
        },
    });

    return newStyle.root;
};
